// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__ODhlx","noInteraction":"EventWrapper_noInteraction__H2vuB","pointerPassthrough":"EventWrapper_pointerPassthrough__2GwVH"};